<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="large"
  color="#fff"
  type="ball-scale-multiple"
  [fullScreen]="true">
  <p style="color: white">Caricamento...</p>
</ngx-spinner>

<app-header></app-header>
<app-login></app-login>
